import React from "react";
import { NotificationManager } from "react-notifications";
import * as dev_constants from '../constants/dev_constants';
import {
  ACTION_UPDATE_ADDRESS
} from "../actions/address.action";

export class TreeNode {
  constructor(id, value) {
    this.id = id;
    this.value = value;
    this.descendants = [];
  }
}

const initialState = {
  address : new TreeNode(1, "Dindigul")
};

export default function addressReducer(state = initialState, action) {
  console.log(`================== addressReducer ============ action=${JSON.stringify(action)} | state=${JSON.stringify(state)}`);
  switch (action.type) {
    case ACTION_UPDATE_ADDRESS: {
      const { payload } = action;
      return {
        ...state,
        address : payload
      };
    }
  }
  return state;
}
